var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEventStats = function SvgEventStats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".event-stats_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "event-stats_svg__bea0cc4f-47b7-4942-817d-78ac5bf41566",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "event-stats_svg__a9795db7-e05f-44bb-bf22-643ce1fbee65",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 17.5a1 1 0 0 0-1 1v5h-14a1 1 0 0 1-1-1v-19a1 1 0 0 1 1-1h19a1 1 0 0 1 1 1v14ZM21.5 17.5l-6 6M3.5.5V5M8.5.5V5M13.5.5V5M18.5.5V5",
    className: "event-stats_svg__st0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5 7.5-3 3L4 9M8.5 13l-3 3L4 14.5M9.912 13.186h.909v2.562h-.909zM11.73 11.051h.909v4.697h-.909zM13.548 12.332h.909v3.416h-.909zM15.366 9.343h.909v6.405h-.909zM17.184 11.051h.909v4.697h-.909zM19.002 7.635h.909v8.113h-.909z",
    className: "event-stats_svg__st0"
  })))));
};
export default SvgEventStats;